/* eslint-disable react/no-danger */
import qs from 'querystring';
import has from 'lodash/has';
import omit from 'lodash/omit';
import noop from 'lodash/noop';
import throttle from 'lodash/throttle';
import classNames from 'classnames';
import UAParser from 'ua-parser-js';
import React, { PureComponent, PropTypes } from 'react';
import ReactImmutablePropTypes from 'react-immutable-proptypes';
import { provideContext, connectToStores } from 'fluxible-addons-react';
import { handleHistory } from 'fluxible-router';
import AppGlyphs from './AppGlyphs.svg';
import Intro from '../Intro';
import Events from '../../utils/Events';
import Visitor from '../../utils/Visitor';
import Debug from '../../utils/Debug';
import { withStyle } from '../../utils/Decorator';

export const getMetrics = () => {
  const width = window.innerWidth > 1366 ? 1366 : window.innerWidth;
  const height = window.innerHeight > 1366 ? 1366 : window.innerHeight;
  return {
    width: width % 2 === 0 ? width : width - 1, // 376; // game's pixel art is at a 1:2 ratio
    height: height % 2 === 0 ? height : height - 1, // 560; // so, even numbers only
  };
};

@provideContext({ insertCss: PropTypes.func.isRequired })
@handleHistory({ enableScroll: false })
@withStyle(require('./App.styl'))
@connectToStores(['AppStore', 'UserStore'], (context) => {
  const AppStore = context.getStore('AppStore');
  return {
    account: context.getStore('UserStore').getAccount(),
    modalOpen: AppStore.getStatus({ key: 'modal_open' }),
    modalBackground: AppStore.getStatus({ key: 'modal_background' }),
    failToInitialize: AppStore.getStatus({ key: 'fail_to_initialize' }),
    gameEnded: AppStore.getStatus({ key: 'game_ended' }),
  };
})
export default class App extends PureComponent {
  static displayName = 'App';

  static propTypes = {
    account: ReactImmutablePropTypes.map.isRequired,
    modalOpen: PropTypes.bool,
    modalBackground: PropTypes.bool,
    failToInitialize: PropTypes.bool,
    gameEnded: PropTypes.bool.isRequired,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    const { width, height } = getMetrics();
    this.events = new Events();
    this.debug = new Debug('main');
    this.query = qs.parse(window.location.search.replace(/^\?/, ''));
    this.state = {
      time: 'normal',
      loading: true,
      debug: false,
      global: false,
      ended: !this.props.account.isEmpty() && this.props.gameEnded,
      close: false,
      moviemode: false,
      waitclick: false,
      intro: false,
      tutorialing: false,
      tutorial: false,
      tutorialTalk: undefined,
      shutter: false,
      buttons: false,
      disconnected: false,
      trophies: undefined,
      socketKilled: false,
      width,
      height,
    };
    this.ua = new UAParser();
  }

  componentWillMount = () => {
    Visitor.pageview();
  };

  componentDidMount = () => {
    this.debug(`%clog mode ${has(this.query, 'log') ? 'ON' : 'OFF'}`, 'font-size:20px;font-weight:bold;font-family:monospace');

    if (!this.props.failToInitialize) {
      // query parser
      const nextQuery = qs.stringify(omit(this.query, ['work_id', 'utm_campaign', 'utm_medium', 'utm_source', 'moviemode']));
      const nextAddress = nextQuery.length > 0 ? `/?${nextQuery}` : '/';
      if (location.href.replace(/^https?:\/\/.+?\//, '/') !== nextAddress) {
        window.history.replaceState(null, null, nextAddress);
      }

      // event listener
      this.handleResize();
      this.events.bind(window, 'resize', this.handleResize);
      this.events.bind(window, 'ws:kill', () => this.setState({ failToInitialize: true }));
      this.events.bind(window, 'ws:dead', () => this.setState({ socketKilled: true }));
      this.events.bind(window, 'app:waitclick', () => this.setState({ waitclick: true }));
      this.events.bind(window, 'app:moviedone', () => this.setState({ moviemode: false, moviedone: true }));

      // ui initializer
      Promise.all([
        this.getImageData({ src: '/images/title.png' }),
        this.getImageData({ src: '/images/sample.png' }),
        new Promise((resolve) => this.events.delay(resolve, 1000)), // 最低1秒待つ
      ]).then(() => {
        this.handleShowIntro().then(() => this.setState({ loading: false }));
        const loader = document.body.querySelector('#loader');
        if (loader) {
          loader.className = '';
          this.events.delay(() => {
            loader.parentNode.removeChild(loader);
            Events.dispatch(window, 'app:initialized');
          }, 240);
        }
      });
    } else {
      this.handleUpdateLoader();
    }
  };

  componentWillUnmount = () => {
    this.events.clear();
  };

  getImageData = ({ src }) => (
    new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = (err) => reject(err);
      img.src = src;
    })
  );

  handleResize = throttle(() => {
    const { width, height } = getMetrics();
    this.setState({ width, height });
  }, 240, { trailing: true });

  handleShowIntro = () => new Promise((resolve) => {
    this.setState({ intro: true }, () => this.events.delay(resolve, 240));
  });

  handleAssignNode = (node) => {
    this.node = node;
  };

  render = () => (
    <div id='App' ref={this.handleAssignNode} className={classNames({ tutorialing: this.state.tutorialing })} style={{ width: this.state.width, height: this.state.height, marginLeft: this.state.width * -0.5, marginTop: this.state.height * -0.5 }}>
      <div dangerouslySetInnerHTML={{ __html: AppGlyphs }} style={{ display: 'none' }} />
      <div id='AppModal' className={classNames({ open: this.props.modalOpen, background: this.props.modalBackground })} />
      <div id='AppIntro' className={classNames({ visible: this.state.intro })}>
        <Intro staffs={this.state.staffs} onEnd={noop} game={this.game} />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/components/App/App.jsx